/**
 * Legacy items slice — DEPRECATED. Ported so the legacy Zustand tests stay
 * green through the monorepo migration. Will be deleted once the last caller
 * of `Item` / `StoreLocation` is removed from the UI (T8 port).
 *
 * Ported from legacy `useStore.ts`: `items`, `stores`, `selectedStoreId`,
 * `setItems`, `setStores`, `setSelectedStore`, `updateItemLocally`,
 * `addItemLocally`.
 *
 * The legacy `Item` type lives in the legacy `frontend/src/types.ts` and is
 * NOT ported to `@shopista/shared/types` — the new arch replaces it with
 * `HouseholdProduct` + `RetailerOffer`. The legacy `Store` shape is now
 * served by `StoreLocation` from `@shopista/shared/types/retailer`. We declare
 * `LegacyItem` / `LegacyStore` inline here with the minimal field set the
 * reducer uses; the tests will widen via `Partial<LegacyItem>` shapes.
 *
 * @deprecated Remove when `Item` / `StoreLocation` are gone from the UI (T8).
 */

export interface LegacyItem {
  id: string;
  household_id: string;
  name: string;
  is_needed?: boolean;
  status?: 'needed' | 'purchased' | string;
  [extra: string]: unknown;
}

export interface LegacyStore {
  id: string;
  household_id: string;
  name: string;
  [extra: string]: unknown;
}

export interface LegacyItemsState {
  items: LegacyItem[];
  stores: LegacyStore[];
  selectedStoreId: string | null;
}

export const initialLegacyItemsState: LegacyItemsState = {
  items: [],
  stores: [],
  selectedStoreId: null,
};

// ---------------------------------------------------------------------------
// Actions
// ---------------------------------------------------------------------------

export function setItems(
  state: LegacyItemsState,
  input: { items: LegacyItem[] }
): LegacyItemsState {
  return { ...state, items: input.items };
}

export function setStores(
  state: LegacyItemsState,
  input: { stores: LegacyStore[] }
): LegacyItemsState {
  return { ...state, stores: input.stores };
}

export function setSelectedStore(
  state: LegacyItemsState,
  input: { storeId: string | null }
): LegacyItemsState {
  return { ...state, selectedStoreId: input.storeId };
}

export function addItemLocally(
  state: LegacyItemsState,
  input: { item: LegacyItem }
): LegacyItemsState {
  return { ...state, items: [...state.items, input.item] };
}

export function updateItemLocally(
  state: LegacyItemsState,
  input: { itemId: string; changes: Partial<LegacyItem> }
): LegacyItemsState {
  let changed = false;
  const next = state.items.map((it) => {
    if (it.id !== input.itemId) return it;
    changed = true;
    return { ...it, ...input.changes };
  });
  if (!changed) return state;
  return { ...state, items: next };
}
